import { create } from 'zustand';

import { createPortalSlice, type PortalSlice } from './createPortalSlice';

export const usePortalStore = create<PortalSlice>()((...args) =>
  createPortalSlice({
    portal: null,
  })(...args),
);
